import axios from "axios";
import moment from "moment/moment";
import {setupAxiosInterceptors} from "./AxiosConfigService";

// Registration request for new user
const registerUser = async (username, rewardsId, dob, ticketNum, zipcode, password) => {
  try {
    const responseData = await axios({
      url: process.env.REACT_APP_REGISTER_USER_URL,
      method: "POST",
      data: {
        username: username,
        rewardsId: parseInt(rewardsId),
        dob: moment(dob, "MM/DD/YYYY").format("MM/DD/YYYY"),
        ticketNum: ticketNum,
        zipCode: zipcode,
        password: password,
        propertyPrefix: process.env.REACT_APP_PROPERTY_PREFIX
      },
    });

    return { success: true, data: responseData };

  } catch (e) {
    return {
      success: false,
      error: e.response ? e.response.data : { message: e.message }
    };
  }
};

// Handles login request for registered users.
const registeredLogin =
  async (username, password) => {
    try {
      const response = await axios({
        url: process.env.REACT_APP_REG_LOGIN_URL,
        method: "POST",
        data: {
          username: username,
          password: password,
        },
        withCredentials: true, // Ensures the jwt token in the SET_COOKIE header is saved in the browser
      });

      // // Extract the token from the Authorization header
      // const authHeader = response.headers["authorization"];
      // const token = authHeader.replace("Bearer ", "");
      //
      // // Set the token for subsequent requests
      // setupAxiosInterceptors(token);

      // Return success with the response data
      return {
        success: true,
        data: response.data,
      }
    } catch (error) {
      return {
        success: false,
        error: error.response ? error.response.data : { message: error.message }
      };
    }
  };

const registeredGetDashboard = async (rewardsId, pageNumber = 0, pageSize = process.env.REACT_APP_PAGE_SIZE) => {

  try {
    let responseData;
    const response = await axios({
      url: process.env.REACT_APP_REG_GET_DASHBOARD_URL,
      method: "POST",
      data: {
        rewardsId: rewardsId ? parseInt(rewardsId) : "",
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
      withCredentials: true,
    });
    responseData = response.data;

    return { success: true, data: responseData };

  }
  catch (error) {
    return {
      success: false,
      error: error.response ? error.response.data : { message: error.message }
    };
  }

}

const registeredClaimRequest =
  async (rewardsId, pageNumber = 0, pageSize = process.env.REACT_APP_DEFAULT_PAGE_SIZE) => {

  try {
    let responseData;
    const response = await axios({
      url: process.env.REACT_APP_REG_CLAIM_URL,
      method: "POST",
      data: {
        rewardsId: rewardsId ? parseInt(rewardsId) : "",
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
      withCredentials: true,
    });
    responseData = response.data;

    return { success: true, data: responseData };

  }
  catch (error) {
    return {
      success: false,
      error: error.response ? error.response.data : { message: error.message }
    };
  }

};

const getCurrentOffers =
  async (rewardsId = null, dob = null, ticketNum = null, zipcode = null,
         pageNumber = 0, pageSize = process.env.REACT_APP_DEFAULT_PAGE_SIZE) => {
  try {
    let responseData;
    const response = await axios({
      url: process.env.REACT_APP_REG_GET_CURRENT_OFFERS_URL,
      method: "POST",
      data: {
        rewardsId: rewardsId ? parseInt(rewardsId) : "",
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
      withCredentials: true,
    });
    responseData = response.data;

    return {success: true, data: responseData};

  } catch (error) {
    return {
      success: false,
      error: error.response ? error.response.data : {message: error.message}
    };
  }
};

const getClaimedOffers =
  async (rewardsId = null, pageNumber = 0, pageSize = process.env.REACT_APP_DEFAULT_PAGE_SIZE) => {

    try {
      let responseData;
      const response = await axios({
        url: process.env.REACT_APP_REG_GET_CLAIMED_URL,
        method: "POST",
        data: {
          rewardsId: rewardsId ? parseInt(rewardsId) : "",
          pageNumber: pageNumber,
          pageSize: pageSize,
        },
        withCredentials: true,
      });
      responseData = response.data;

      return { success: true, data: responseData };

    }
    catch (error) {
      return {
        success: false,
        error: error.response ? error.response.data : { message: error.message }
      };
    }
  };

const getClaimedLegacyOffers =
  async (rewardsId, pageNumber = 0, pageSize = process.env.REACT_APP_DEFAULT_PAGE_SIZE) => {

    try {
      let responseData;
      const response = await axios({
        url: process.env.REACT_APP_REG_GET_CLAIMED_LEGACY_URL,
        method: "POST",
        data: {
          rewardsId: rewardsId ? parseInt(rewardsId) : "",
          pageNumber: pageNumber,
          pageSize: pageSize,
        },
        withCredentials: true,
      });
      responseData = response.data;

      return { success: true, data: responseData };

    }
    catch (error) {
      return {
        success: false,
        error: error.response ? error.response.data : { message: error.message }
      };
    }
  };

const logout = async () => {

    try {
      let responseData;
      const response = await axios({
        url: process.env.REACT_APP_REG_USER_LOGOUT_URL,
        method: "POST",
        withCredentials: true,
      });
      responseData = response.data;

      return { success: true, data: responseData };

    }
    catch (error) {
      return {
        success: false,
        error: error.response ? error.response.data : { message: error.message }
      };
    }
  };

// When the user fills out the reset password form
const resetPasswordExecute = async (password, code) => {
  try {
    const response = await axios({
      url: process.env.REACT_APP_REG_RESET_PASSWORD_EXECUTE_URL,
      method: "POST",
      data: {
        password: password,
        code: code
      },
    });

    return { success: true, data: response.data };

  } catch (e) {
    return {
      success: false,
      error: e.response ? e.response.data : { message: e.message }
    };
  }
};

// When a user clicks on the forgot password link
const resetPasswordRequest = async (email) => {
  try {
    const response = await axios({
      url: process.env.REACT_APP_REG_RESET_PASSWORD_REQUEST_URL,
      method: "POST",
      data: {
        email: email,
      },
    });

    return { success: true, data: response.data };

  } catch (e) {
    return {
      success: false,
      error: e.response ? e.response.data : { message: e.message }
    };
  }
};




const registeredUserService = {
  registerUser,
  registeredLogin,
  registeredGetDashboard,
  registeredClaimRequest,
  getCurrentOffers,
  getClaimedOffers,
  getClaimedLegacyOffers,
  logout,
  resetPasswordRequest,
  resetPasswordExecute
};
export default registeredUserService;
